export const VIEW_MODES = {
  FULL: "page-full",
  SIDE: "page-side",
  FIXED: "page-fixed",
};
